import React, { useState, useEffect } from "react";
import Tooltip from "../../tooltip";

import Select from "../../select/select_v2";
import SignatureTypeCards from "../../signatureTypeCards";
import Button from "../../button/button_v2";
import api from "../../../services/api";
import { Container } from "react-grid-system";
import Input from "../../input/input_v2";
import { FormContainer, Loading } from "./styles";
import { store } from "react-notifications-component";
import iconQuestionBlue from "../../../assets/icons/icon-question-blue.png";
import ModalUpload from '../../modal/modalUploadCertificado';
import Modal from '../../modal';
import { ModalBody, ModalTitle } from '../../modal/styles';
import InputSign from '../../inputSign';

import identifyErrorMenssage from "../../../services/identifyErrorMenssage";
export const USER = "@userinfo";

const SIGN_LABELS = { M: 'Manual', D: 'Digital', E: 'Eletrônica' };

const AddCreas = ({ ...props }) => {

    const { agronomoId } = props;

    const [nome, setNome] = useState('');
    const [agronomo, setAgronomo] = useState('');
    const [filial, setFilial] = useState('');
    const [numeroCrea, setNumeroCrea] = useState('');
    const [tipoId, setTipoId] = useState('');
    const tipos = [{
        value: 'crea', label: 'CREA'
    }, {
        value: 'visto', label: 'VISTO'
    }, {
        value: 'cfta', label: 'CFTA'
    }];
    const [receitaInicial, setReceitaInicial] = useState('');
    const [receitasEmitidas, setReceitasEmitidas] = useState('');
    const [status] = useState({value: 1, label: 'Ativo'});
    const [homologAutomatico, setHomologAutomatico] = useState('');

    const estados = [
        { value: "NACIONAL", label: "Nacional" },
        { value: "SP", label: "São Paulo" },
        { value: "RJ", label: "Rio de Janeiro" },
        { value: "SC", label: "Santa Catarina" },
        { value: "AC", label: "Acre" },
        { value: "AL", label: "Alagoas" },
        { value: "AP", label: "Amapa" },
        { value: "AM", label: "Amazonas" },
        { value: "BA", label: "Bahia" },
        { value: "CE", label: "Ceará" },
        { value: "DF", label: "Distrito Federal" },
        { value: "ES", label: "Espirito Santo" },
        { value: "GO", label: "Goiás" },
        { value: "MA", label: "Maranhão" },
        { value: "MT", label: "Mato Grosso" },
        { value: "MS", label: "Mato Grosso do Sul" },
        { value: "MG", label: "Minas Gerais" },
        { value: "PA", label: "Pará" },
        { value: "PB", label: "Paraíba" },
        { value: "PR", label: "Paraná" },
        { value: "PE", label: "Pernambuco" },
        { value: "PI", label: "Piaui" },
        { value: "RN", label: "Rio Grande do Norte" },
        { value: "RS", label: "Rio Grande do Sul" },
        { value: "RO", label: "Rondônia" },
        { value: "RR", label: "Roraima" },
        { value: "SE", label: "Sergipe" },
        { value: "TO", label: "Tocantins" },
        { value: "", label: "" }
    ];

    const estados1 = [
        { value: "SP", label: "São Paulo" },
        { value: "RJ", label: "Rio de Janeiro" },
        { value: "SC", label: "Santa Catarina" },
        { value: "AC", label: "Acre" },
        { value: "AL", label: "Alagoas" },
        { value: "AP", label: "Amapa" },
        { value: "AM", label: "Amazonas" },
        { value: "BA", label: "Bahia" },
        { value: "CE", label: "Ceará" },
        { value: "DF", label: "Distrito Federal" },
        { value: "ES", label: "Espirito Santo" },
        { value: "GO", label: "Goiás" },
        { value: "MA", label: "Maranhão" },
        { value: "MT", label: "Mato Grosso" },
        { value: "MS", label: "Mato Grosso do Sul" },
        { value: "MG", label: "Minas Gerais" },
        { value: "PA", label: "Pará" },
        { value: "PB", label: "Paraíba" },
        { value: "PR", label: "Paraná" },
        { value: "PE", label: "Pernambuco" },
        { value: "PI", label: "Piaui" },
        { value: "RN", label: "Rio Grande do Norte" },
        { value: "RS", label: "Rio Grande do Sul" },
        { value: "RO", label: "Rondônia" },
        { value: "RR", label: "Roraima" },
        { value: "SE", label: "Sergipe" },
        { value: "TO", label: "Tocantins" },
        { value: "", label: "" }
    ];
    const [estadoId, setEstadoId] = useState(estados || "");
    
    const [isCrea, setIsCrea] = useState(false);
    const [isVisto, setIsVisto] = useState(false);
    const [EsconderBotao, setEsconderBotao] = useState(false);


    const [usuario, setUsuario] = useState('');
    const [senha, setSenha] = useState('');
    const [typePassword, setTypePassword] = useState('password');

    const [tiposAssinatura, setTiposAssinatura] = useState([
        {value: 'M', label: 'Manual'},
        {value: 'D', label: 'Digital'},
        {value: 'E', label: 'Eletrônica'}
    ]);
    const [assinaturaId, setAssinaturaId] = useState('');

    const [loading, setLoading] = useState(false);

    const [erroCrea, setErroCrea] = useState(false);
    const [erroCreaMsg, setErroCreaMsg] = useState('');
    const [contractSoftId, setContractSoftId] = useState('');

    const [blockSign, setBlockSign] = useState(false);
    const [isLoadingSignRules, setIsLoadingSignRules] = useState(false);
    const [showModalUpload, setShowModalUpload] = useState(false);
    const [showSignatureModal, setShowSignatureModal] = useState(false);
    const [hasDigitalCredential, setHasDigitalCredential] = useState(false);
    const [hasElectronicCredential, setHasElectronicCredential] = useState(false);

    const modalUploadClose = (password) => {
        if (password) {
            setHasDigitalCredential(true);
        } else {
            setAssinaturaId({ value: 'M', label: 'Manual' });
        }
        setShowModalUpload(false);
    }

    const saveElectronicSignature = async (dataUri) => {
        try {
            const payload = {
                nome: agronomo?.nome ?? nome,
                cpf: agronomo?.cpf ?? '',
                email: agronomo?.email ?? '',
                enviar_receita: agronomo?.enviar_receita,
                whatsapp: agronomo?.whatsapp ?? '',
                assinatura: dataUri,
            };
            const response = await api.put(`/agronomos/${agronomoId}`, payload);
            if (response) {
                setHasElectronicCredential(true);
                setShowSignatureModal(false);
                store.addNotification({
                    title: "Sucesso!",
                    message: `Assinatura salva com sucesso!`,
                    type: "success",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: { duration: 4000, onScreen: true }
                });
            }
        } catch (error) {
            store.addNotification({
                title: "Erro!",
                message: identifyErrorMenssage(error),
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: { duration: 4000, onScreen: true }
            });
        }
    }

    const selectAssinatura = (ass) => {
        setAssinaturaId(ass);
    }

    const validateNumeroCrea = numeroCrea => {
        setNumeroCrea(numeroCrea);
    }
    const validateReceitaInicial = receitaInicial => {
        let inputWithErrors = document.querySelectorAll(".error");

        for (let input of inputWithErrors) {
            input.classList.remove("error");
        }

        setReceitaInicial(receitaInicial);
    }
    const validateReceitaZero = valor => {
        if(valor == 0){
            setReceitaInicial('');
            
            const select = document.getElementById("receita_inicial");
            select.classList.add("error");

            store.addNotification({
                title: "Erro!",
                message: `O campo receita inicial deve ser maior que zero`,
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 4000,
                    onScreen: true
                }
            });
        }
    }

    //Função para buscar os agronomos
    const getAgronomos = async () => {
        try {
            const response = await api.get(`/agronomos/${agronomoId}`);
            const agronomo = response.data.data;
            setAgronomo(agronomo);
            setNome(agronomo.nome);
            setFilial(agronomo.filial.nome_fantasia);
            if (typeof agronomo.assinatura === 'string' && agronomo.assinatura.startsWith('data:image')) {
                setHasElectronicCredential(true);
            } else if (typeof agronomo.assinatura === 'string' && agronomo.assinatura.startsWith('data:')) {
                setHasDigitalCredential(true);
            }
            if (agronomo.creas.length > 0) {

                agronomo.creas.map(c => {
                    if(c.status == 1 ){
                        setIsCrea(true);
                    }
                })
            }
        } catch (error) {
        }
    };

    const validaEstadoVisto = async () => {
        agronomo.creas.map(c => {
            if(c.tipo == 'crea' && c.estado == estadoId && c.status == 1){
                setErroCrea(true);
                setErroCreaMsg('Responsável Técnico já possui CREA cadastrado');

                store.addNotification({
                    title: "Erro!",
                    message: `O Responsável Técnico já possui CREA cadastrado nesse estado! `,
                    type: "danger",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                        duration: 4000,
                        onScreen: true
                    }
                })
            }else if(c.tipo == 'visto' && c.estado == estadoId && c.status == 1){
                setErroCrea(true);
                setErroCreaMsg('Responsável Técnico já possui VISTO cadastrado para esse estado!');


                store.addNotification({
                    title: "Erro!",
                    message: `O Responsável Técnico já possui VISTO cadastrado para esse estado! `,
                    type: "danger",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                        duration: 4000,
                        onScreen: true
                    }
                })
            }else{
                setErroCrea(false);
            }
        })

    };

    const handlePost = async e => {
        setLoading(true);

        const payload = {
            estado: estadoId.value ? estadoId.value :  estadoId,
            homologar_automatico: (
                estadoId.value === 'MT' || estadoId.value === 'SC' || estadoId.value === 'ES' || estadoId.value === 'GO' || estadoId.value === 'DF' || estadoId === 'NACIONAL'
            ) && contractSoftId != 6 ? 1 : 0,            
            crea: numeroCrea,
            tipo: tipoId.value,
            status: status.value,
            receita_inicial: receitaInicial,
            receitas_emitidas: receitasEmitidas,
            filial: filial,
            assinatura: assinaturaId.value,
            usuario,
            senha,
        }

        try {
            const responsee = await api.post(`/agronomos/${agronomoId}/creas`, payload);
            setLoading(false);
            window.location.href = `/agronomos/${agronomoId}`;
            return (<>

                {store.addNotification({
                    title: "Sucesso!",
                    message: `O ${tipoId.label} foi salvo`,
                    type: "success",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                        duration: 4000,
                        onScreen: true
                    }
                })

                }
            </>)
        } catch (err) {
            setLoading(false);

            try {
                let inputWithErrors = document.querySelectorAll(".error");
    
                for (let input of inputWithErrors) {
                    input.classList.remove("error");
                }
    
                const errors = err.response.data.errors;
    
                for (let field in errors) {
                    const input = document.getElementById(field);
                    input.classList.add("error");
                    if(errors.estado){
                        field = field+ " : " +errors.estado.existant;
                    }
                }

                store.addNotification({
                    title: "Erro!",
                    message: `Verifique os campos em vermelho!`,
                    type: "danger",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                        duration: 4000,
                        onScreen: true
                    }
                });
                
            } catch (error) {
                store.addNotification({
                    title: "Erro!",
                    message: identifyErrorMenssage(err),
                    type: "danger",
                    insert: "top",
                    container: "top-right",
                    animationIn: ["animated", "fadeIn"],
                    animationOut: ["animated", "fadeOut"],
                    dismiss: {
                        duration: 4000,
                        onScreen: true
                    }
                });
            }
        }
    }

    const getTiposAssinatura = async (estado) => {
        try {
            if (estado) {
                setIsLoadingSignRules(true);
                setTiposAssinatura([]);
                const response = await api.get(`/sign/estado/${estado}`);
    
                const tipos = response.data.data;
                let tipo = []
    
                if (tipos.manual === true) {
                    tipo = [...tipo, {value: 'M', label: 'Manual'}];
                } 
                if (tipos.digital === true) {
                    tipo = [...tipo, {value: 'D', label: 'Digital'}]; 
                }
                if (tipos.eletronica === true) {
                    tipo = [...tipo, {value: 'E', label: 'Eletrônica'}]; 
                }
    
                setTiposAssinatura(tipo);
            }
        } catch (error) {
            setTiposAssinatura([
                {value: 'M', label: 'Manual'},
                {value: 'D', label: 'Digital'},
                {value: 'E', label: 'Eletrônica'}
            ]);
        } finally {
            setIsLoadingSignRules(false);
        }
    }

    const changeTipoCrea = (tipo) => {
        if (tipo) {
            if (tipo.value != tipoId.value) {
                setTipoId(tipo);
                if(tipo.value === 'cfta') {
                    setEstadoId('NACIONAL');
                }else {
                    if (estadoId.value == 'NACIONAL') {
                        setEstadoId({value: '', label: ''});
                    }
                }
            }
        } else {
            setTipoId('');
        }
    }

    const changeEstado = (estado) => {
        if (estadoId === '') {
            setEstadoId(estado);

            if (estado.value === 'NACIONAL') {
                setTipoId({value: 'cfta', label: 'CFTA'});
            }

            if (estado.value) {
                getTiposAssinatura(estado.value);
            }
        } else if (estadoId.value != estado.value) {
            setEstadoId(estado);
            
            if (estado.value === 'NACIONAL') {
                setTipoId({value: 'cfta', label: 'CFTA'});
            }

            if (estado.value) {
                getTiposAssinatura(estado.value);
            }
        }
    }

    useEffect(() => {
        if (agronomoId) {
            getAgronomos();
        }

        let user = JSON.parse(localStorage.getItem(USER));

        setContractSoftId(user.contract_software_id);

        user.contrato.agro_plan_functions.map((e) => {
            if (e.agro_plans_function.id === 9) {
                if (e.status === 0) {
                    setBlockSign(true);
                }
            }
        });

        setHomologAutomatico({value: 0, label: 'Não'});
    }, [])


    useEffect(() => {
        if ((tipoId.value == 'crea') && isCrea == true) {
            setErroCrea(true);
            setErroCreaMsg('Responsável Técnico já possui CREA');

            setEsconderBotao(true);

            store.addNotification({
                title: "Erro!",
                message: `O Responsável Técnico já possui CREA cadastrado! `,
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animated", "fadeIn"],
                animationOut: ["animated", "fadeOut"],
                dismiss: {
                    duration: 4000,
                    onScreen: true
                }
            })
        } else {
            setErroCrea(false);
            if(tipoId.value == 'visto'){
                validaEstadoVisto();
            }else if(tipoId.value == 'cfta'){

            }
            setEsconderBotao(false);

        }
    }, [tipoId]);

    useEffect(() => {
        if (tiposAssinatura.length > 0) {
            selectAssinatura({value: 'M', label: 'Manual'})
        }
    },[tiposAssinatura]);




    return (<>

        <FormContainer { ...props }>
            <Container>

                <form 
                    style={ estadoId === 'RJ' ? {marginTop:"119px"}: {marginTop:"50px"}}
                >
                    <Input
                        name="responsavelTecnico"
                        type="text"
                        label="Responsável Técnico"
                        id="responsavelTecnico"
                        value={nome}
                    />

                    <Input
                        name="filial"
                        type="text"
                        label="Filial"
                        id="filial"
                        value={filial}
                    />

                    <Select
                        name="tipo"
                        className="select"
                        label="Tipo"
                        id="tipo"
                        disabled={false}
                        value={tipoId.value || tipoId}
                        onChange={tipo => changeTipoCrea(tipo)}
                        options={tipos}
                        selectUniqueOption={true}
                        erro={erroCrea}
                        messageErro={erroCreaMsg}
                    />

                    {tipoId.value == 'cfta' ? (
                        <Select
                            name="estado"
                            className="select"
                            label="Estado"
                            id="estado"
                            disabled={true}
                            value={"NACIONAL"}
                            estado={true}
                            onChange={estado => (changeEstado(estado))}
                            options={estados}
                            selectUniqueOption={true}
                        />
                    ):(
                        <Select
                            name="estado"
                            className="select"
                            label="Estado"
                            id="estado"
                            disabled={false}
                            value={estadoId.value != '' ? estadoId.value : '' }
                            estado={true}
                            onChange={estado => (changeEstado(estado))}
                            options={estados1}
                            selectUniqueOption={true}
                        />
                    )}

                    <Input
                        name="numeroCrea"
                        type="text"
                        label="Número Crea/Visto/CFTA"
                        id="crea"
                        onChange={e => validateNumeroCrea(e)}
                    />

                    {estadoId === "SC" || estadoId.value === 'SC' ? (
                        <>
                            <Input 
                                name="user"
                                type="text"
                                label="Usuário SIGEN"
                                onChange={e => setUsuario(e)}
                                value={usuario}
                                id='userId'
                            />

                            <div className="senha">
                                <Input 
                                    name="pass"
                                    type={typePassword}
                                    label="Senha SIGEN"
                                    onChange={e => setSenha(e)}
                                    value={senha}
                                    id='passId'
                                />
                            </div>
                        </>
                    ):(<>
                        {estadoId === "ES" || estadoId.value === 'ES' ? (
                            <>
                                <Input 
                                    name="user"
                                    type="text"
                                    label="Usuário IDAF"
                                    id='userId'
                                    onChange={e => setUsuario(e)}
                                    value={usuario}
                                />

                                <div className="senha">
                                    <Input 
                                        name="pass"
                                        type={typePassword}
                                        label="Senha IDAF"
                                        onChange={e => setSenha(e)}
                                        value={senha}
                                        id='passId'
                                    />
                                </div> 
                            </>
                        ):(
                            null
                        )}
                    </>)}

                    {isLoadingSignRules ? (
                        <div style={{ width: '100%', display: 'flex', justifyContent: 'center', marginBottom: '14px' }}>
                            <Loading />
                        </div>
                    ) : (
                        <div style={{ width: '100%', marginBottom: '14px' }}>
                            <SignatureTypeCards
                                value={assinaturaId.value || assinaturaId}
                                onChange={(type) => selectAssinatura({ value: type, label: SIGN_LABELS[type] })}
                                allowedSignatures={tiposAssinatura.map((t) => t.value)}
                                estadoValue={estadoId.value || estadoId}
                                hasDigitalCredential={hasDigitalCredential}
                                hasElectronicCredential={hasElectronicCredential}
                                namePrefix="card_radio_assinatura_crea"
                                responsavelNome={agronomo?.nome ?? nome}
                                onUploadCertificado={() => setShowModalUpload(true)}
                                onCadastrarAssinatura={() => setShowSignatureModal(true)}
                            />
                        </div>
                    )}

                    {estadoId === 'RJ'  || estadoId.value === 'RJ' ? 
                    <div style={{width: '100%', height: 'auto', display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                        <Input
                            name="receitaInicial"
                            type="text"
                            label="Receita Inicial"
                            id="receita_inicial"
                            value={receitaInicial}
                            onChange={e => validateReceitaInicial(e)}
                            onBlur={e => validateReceitaZero(e.target.value)}
                            marginBottom="0"
                        />

                        <Tooltip
                            content={<div style={{ textAlign: 'left', padding: '10px', maxWidth: '280px' }}>
                                Ex: Se você já emitiu 20 receitas com esta ART, coloque aqui 21.
                            </div>}
                            animation="fade"
                            delay={[300, 100]}
                            arrow={true}
                            placement="right"
                        >
                            <img src={iconQuestionBlue} alt="Ajuda" style={{ width: '20px', height: '20px', marginLeft: '8px', cursor: 'pointer' }} />
                        </Tooltip>
                    </div> : null}

                    <div className="button-add" style={{ width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'center', marginTop: '40px', marginBottom: '60px' }}>
                        <Button 
                            width='100%'
                            height='50px'
                            value='CADASTRAR'
                            outline={false}
                            disabled={EsconderBotao || isLoadingSignRules}
                            onClick={() => handlePost()}
                            loading={loading}
                        />
                    </div>
                </form>
            </Container>
        </FormContainer>

        {showModalUpload ? (
            <ModalUpload
                show={showModalUpload}
                onHide={(password) => modalUploadClose(password)}
                cpf={agronomo?.cpf}
            />
        ) : null}

        <Modal
            show={showSignatureModal}
            onHide={() => setShowSignatureModal(false)}
            align="center"
            justify="center"
            responsive
            width="480px"
        >
            <ModalTitle>Cadastrar assinatura eletrônica</ModalTitle>

            <ModalBody>
                <InputSign
                    sign=""
                    update={(dataUri) => saveElectronicSignature(dataUri)}
                />
            </ModalBody>
        </Modal>
    </>);
};

export default AddCreas;
